import { gql } from '@apollo/client/core';

// Where in documentIds
export const GET_TOUR_RANK_BY_TOUR_CATEGORIES = gql`
    query GetTournamentRankByCategories($page: Int!, $pageSize: Int!, $documentIds: [ID!], $keyword : String!) {
        tournamentRanks_connection(
            filters: {
                and: [
                    {
                        or: [
                            {
                                category: {
                                    documentId: {
                                        in: $documentIds
                                    }
                                }
                            },
                            {
                                category: {
                                    documentId: {
                                        eq: "___NO_MATCH___"
                                    }
                                }
                            }
                        ]
                    },
                    {
                        or: [
                            {
                                tour_player_team: {
                                    or: [
                                        { player_1: { display_name: { contains: $keyword } } },
                                        { player_2: { display_name: { contains: $keyword } } }
                                    ]
                                }
                            },
                            {
                                category: {
                                    name: {
                                        contains: $keyword
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
            pagination: { page: $page, pageSize: $pageSize }
            sort: ["category.name:desc", "rank:asc", "point:desc"]
        ) {
            nodes {
                documentId
                tournaments {
                    documentId
                    name
                }
                category {
                    documentId
                    name
                }
                tour_player_team {
                    documentId
                    player_1 {
                        documentId
                        display_name
                    }
                    player_2 {
                        documentId
                        display_name
                    }
                }
                total_wins
                total_losses
                sets_won
                sets_lost
                set_diff
                points_won
                points_lost
                rank
                point
            }
            pageInfo {
                page
                pageCount
                pageSize
                total
            }
        }
    }
`;

export const GET_CATEGORY_RANKS = gql`
    query CategoryRanks(
        $filters: CategoryRankFiltersInput
        $pagination: PaginationArg
        $sort: [String]
    ) {
        categoryRanks(
            filters: $filters
            pagination: $pagination
            sort: $sort
        ) {
            documentId
            rank
            point
            tour_player_team {
                player_1 {
                    documentId
                    last_name
                    middle_name
                    first_name
                    display_name
                }
                player_2 {
                    documentId
                    last_name
                    middle_name
                    first_name
                    display_name
                }
            }
        }
    }
`;

export const GET_CATEGORY_RANKS_BY_PLAYER = gql`
    query CategoryRanks(
        $filters: CategoryRankFiltersInput
        $pagination: PaginationArg
        $sort: [String]
    ) {
        categoryRanks(
            filters: $filters
            pagination: $pagination
            sort: $sort
        ) {
            documentId
            rank
            point
            tour_player_team {
                player_1 {
                    documentId
                    last_name
                    middle_name
                    first_name
                    display_name
                }
                player_2 {
                    documentId
                    last_name
                    middle_name
                    first_name
                    display_name
                }
            }
        }
    }
`;

export const GET_CATEGORY_TEAM_RANKS = gql`
    query CategoryTeamRanks(
        $filters: CategoryTeamRankFiltersInput
        $pagination: PaginationArg
        $sort: [String]
    ) {
        categoryTeamRanks(
            filters: $filters
            pagination: $pagination
            sort: $sort
        ) {
            point
            rank
            team {
                documentId
                name
            }
        }
    }
`;